<h1 mat-dialog-title>Therapist Working Days</h1>

<mat-dialog-content>
    <p>Select which days te therapist is working at this event</p>
@if (therapistEventDetail){
    @for (detail of therapistEventDetail; track detail){

        <div [class.disabled-card]="isReloading" class="card my-2 p-3 rounded-0">
            <div class="row">
                <div class="col">
<p class="mb-0">{{detail.startDate|date:'dd MMM YYYY'}}</p>
                </div>
                <div class="col-auto">
    <mat-slide-toggle (change)="onToggle($event, detail.therapistEventID!, detail.active!)" [checked]="detail.active">WORKING&nbsp;</mat-slide-toggle>
                </div>
            </div>
        </div>
    }
}


    <button class="d-block d-lg-inline-block w-100 mt-3" mat-dialog-close mat-flat-button color="primary">CLOSE</button>


</mat-dialog-content>